<template>
	<BaseCmsPage v-slot="{page}">
		<Body class="manufacturers-layout center-title" />
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>

		<BaseCatalogManufacturers :fetch="{special: 1, limit: 10, sort: 'position_h'}" thumbPreset="manufacturers" v-slot="{items}">
			<div class="featured-brands" v-if="items?.length">
				<div class="wider-wrapper">
					<div class="featured-brands-cnt">
						<NuxtLink v-for="manufacturer in items" :key="manufacturer.id" :to="manufacturer.url_without_domain" class="fb-manufacturer">
							<BaseUiImage :data="manufacturer.main_image_thumbs?.['width160-height70']" default="/images/no-image-200.jpg" loading="lazy" />
						</NuxtLink>
					</div>
				</div>
			</div>
		</BaseCatalogManufacturers>

		<BaseCatalogManufacturers :fetch="{hierarchy_by: 'alphabet', limit: 0, sort: 'title'}" v-slot="{items}">
			<div class="m-items">
				<div class="wider-wrapper">
					<div class="m-items-cnt">
						<template v-if="items?.length">
							<div class="m-column" v-for="manufacturer in items" :key="manufacturer.alphabet">
								<h3 class="m-letter" :id="manufacturer.alphabet">{{ manufacturer.alphabet }}</h3>
								<ul class="m-list">
									<li v-for="item in manufacturer.items" :key="item.id">
										<div class="m-title">
											<NuxtLink :to="item.url_without_domain">{{ item.title }}</NuxtLink>
										</div>
									</li>
								</ul>						
							</div>							
						</template>
						<template v-else><BaseCmsLabel code="no_manufacturers" /></template>
					</div>
				</div>
			</div>
		</BaseCatalogManufacturers>
	</BaseCmsPage>
</template>
